// src/config.js
export const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://127.0.0.1:8000/api/v1"
    : "https://secrableapiv1.onrender.com/api/v1";


    // https://secrableapiv1.onrender.com


export function parseJwt(token) {
  try {
    const base64Payload = token.split(".")[1]; // second part of JWT
    const payload = atob(base64Payload); // decode base64
    return JSON.parse(payload);
  } catch (error) {
    console.error("Invalid token", error);
    return null;
  }
}